import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

import { formatCurrency, formatNumber } from 'utils/formats';

import { useAcceptTradingOfferModal } from '../context/AcceptTradingOfferModalContext';

const AcceptTradingOfferModalStep1: FC = () => {
  const { t } = useTranslate();
  const { data } = useAcceptTradingOfferModal();

  const totalPrice = data.purchaseQuantity * data.offer.sharePrice;

  return (
    <div className="nk-stepper-step active">
      <div className="text-center mb-4">
        <em className="icon ni ni-file-text fs-24px text-primary" />
        <h5 className="mt-2">{t('OperationSummary')}</h5>
        <p className="text-soft">
          {t('ReviewPurchaseDetailsBeforeContinuing')}
        </p>
      </div>

      <div className="card card-bordered bg-light">
        <div className="card-inner">
          <div className="row">
            <div className="col-6 my-2">
              <span className="text-soft d-block fs-12px">
                {t('OfferReference')}
              </span>
              <strong>{data.offerReference}</strong>
            </div>
            <div className="col-6 my-2">
              <span className="text-soft d-block fs-12px">
                {t('Seller')}
              </span>
              <strong>{data.sellerName}</strong>
            </div>
            <div className="col-6 my-2">
              <span className="text-soft d-block fs-12px">
                {t('Class')}
              </span>
              <strong>{data.className}</strong>
            </div>
            <div className="col-6 my-2">
              <span className="text-soft d-block fs-12px">
                {t('SharesToBuy')}
              </span>
              <strong className="text-success">
                {formatNumber(data.purchaseQuantity)}{' '}
                {t('Shares').toLowerCase()}
              </strong>
            </div>
            <div className="col-6 my-2">
              <span className="text-soft d-block fs-12px">
                {t('PricePerShare')}
              </span>
              <strong>{formatCurrency(data.offer.sharePrice)}</strong>
            </div>
            <div className="col-6 my-2">
              <span className="text-soft d-block fs-12px">
                {t('TotalAmount')}
              </span>
              <strong className="text-success fs-16px">
                {formatCurrency(totalPrice)}
              </strong>
            </div>
          </div>
        </div>
      </div>

      <div className="alert alert-warning alert-icon mt-3">
        <em className="icon ni ni-alert-circle" />
        <p className="mb-0 fs-13px">{t('AcceptOfferWarningMessage')}</p>
      </div>
    </div>
  );
};

export default AcceptTradingOfferModalStep1;
